






import { Component, Vue } from 'vue-property-decorator'
import api from '@/services/api'

@Component
export default class extends Vue {
    src = '';
    async created() {
        console.log(api);
        const result = await api.service('gifs').get('5e9337310bba263c54d9f751');
        console.log(result);
        this.src = 'data:video/mp4;base64,'+result.a
    }
}
